import { useRequiredContext } from "@redotech/react-util/context";
import WelcomeIcon from "@redotech/redo-icons/sun-setting-02.svg";
import WelcomeFilledIcon from "@redotech/redo-icons/sun-setting-02_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { ConversionSuiteStatusesContext } from "../../../../redo-suite/conversion-cloud";

export const OnboardingItems = memo(function OnboardingItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { checkoutOutboundRatesEnabled } = useRequiredContext(
    ConversionSuiteStatusesContext,
  );

  if (!checkoutOutboundRatesEnabled) {
    return (
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getConversionSubRoute("onboard") }}
        FilledIcon={WelcomeFilledIcon}
        friendlyName="Welcome"
        id="onboarding"
        UnfilledIcon={WelcomeIcon}
      />
    );
  } else {
    return null;
  }
});
